<script setup>
import { useI18n } from 'vue-i18n';

import { formStore } from '@/stores/form';
const { t } = useI18n();

const { language } = formStore();

defineProps({
  name: {
    type: String,
    required: true,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  minDate: {
    type: Date,
    default: null,
  },
  maxDate: {
    type: Date,
    default: null,
  },
  defaultValue: {
    type: Date,
    default: null,
  },
  pickerOnly: {
    type: Boolean,
    default: false,
  },
  placeHolder: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <FormKit
    data-wg-notranslate
    type="datepicker"
    :name="name"
    :label="label"
    :value-locale="language"
    :format="t('general.dateFormat')"
    value-format="YYYY-MM-DD"
    :min-date="minDate"
    :max-date="maxDate"
    :value="defaultValue"
    :picker-only="pickerOnly"
    :placeholder="t('general.dateFormat').toLowerCase()"
    inputmode="numeric"
    clearable
  />
</template>
